export default {
  Apply: {
    Resume: [
      "https://github.com/aneagoie/resume-checklist",
      "https://www.resumemaker.online/",
      "https://thisresumedoesnotexist.com/",
      "https://www.cakeresume.com/Engineering-resume-samples",
    ],
    JobScan: [
      "https://www.jobscan.co/",
      "https://github.com/zero-to-mastery/ZtM-Job-Board",
      "https://zero-to-mastery.github.io/ZtM-Job-Board/",
    ],
    JobBoards: [
      "https://weworkremotely.com/",
      "https://angel.co/",
      "https://triplebyte.com/",
      "https://whitetruffle.com/",
      "https://hired.com/x/a17a64b1eafce885d204c36fe3e66831",
    ],
    Negotiation: [
      "https://www.salary.com/",
      "https://www.glassdoor.com/index.htm",
      "https://www.payscale.com/",
    ],
    Avatars: ["https://en.gravatar.com/"],
    Portfolio: ["https://github.com/cobidev/simplefolio"],
  },
  Javascript_Libraries: {
    CLI: [
      "https://www.npmjs.com/package/chalk",
      "https://www.npmjs.com/package/ansi-styles",
      "https://www.npmjs.com/package/has-flag",
      "https://www.npmjs.com/package/supports-color",
      "https://www.npmjs.com/package/caporal",
      "https://www.npmjs.com/package/colors",
    ],
    ColorConversion: [
      "https://www.npmjs.com/package/color-convert",
      "https://www.npmjs.com/package/color-name",
    ],
    Contact: [
      "https://mailchimp.com/",
      "https://customer.io/",
      "https://mailsac.com/",
      "https://github.com/leemunroe/responsive-html-email-template",
      "https://mailtrap.io/",
      "https://www.mailgun.com/",
      "https://sendgrid.com/",
      "https://www.twilio.com/docs/sms/send-messages",
    ],
    Debugging: [
      "https://www.npmjs.com/package/morgan",
      "https://www.npmjs.com/package/ndb",
    ],
    ENV: [
      "https://www.npmjs.com/package/dotenv",
      "https://www.npmjs.com/package/cross-env",
      "https://www.npmjs.com/package/config",
      "https://www.npmjs.com/package/rc",
    ],
    Geographic: [
      "https://www.mapbox.com/",
      "https://imakewebthings.com/waypoints/",
      "https://ch-ny.com/content/themes/bridge-child/js/libs/maplace.js/",
    ],
    Geomerty: [
      "https://brm.io/matter-js/",
      "https://threejs.org/",
      "https://github.com/react-spring/react-three-fiber",
      "https://medium.com/better-programming/react-three-fiber-build-3d-for-the-web-with-react-and-webgl-easily-c0df8801292",
    ],
    Images: [
      "https://www.npmjs.com/package/multer",
      "https://www.npmjs.com/package/sharp",
      "https://gijsroge.github.io/tilt.js/",
    ],
    Linting: [
      "https://www.npmjs.com/package/eslint-config-prettier",
      "https://www.npmjs.com/package/eslint-plugin-prettier",
      "https://www.npmjs.com/package/eslint-config-airbnb",
      "https://www.npmjs.com/package/eslint-plugin-node",
      "https://www.npmjs.com/package/eslint-plugin-import",
      "https://www.npmjs.com/package/eslint-plugin-jsx-a11y",
      "https://www.npmjs.com/package/eslint-plugin-react",
    ],
    Popups: [
      "https://dimsemenov.com/plugins/magnific-popup/",
      "https://popper.js.org/",
    ],
    Recognition: [
      "https://www.npmjs.com/package/clarifai",
      "https://www.clarifai.com/models",
    ],
    Security: [
      "https://www.npmjs.com/package/xss-clean",
      "https://www.npmjs.com/package/hpp",
      "https://www.npmjs.com/package/express-mongo-sanitize",
      "https://www.npmjs.com/package/helmet",
      "https://www.npmjs.com/package/express-rate-limit",
      "https://www.npmjs.com/package/jsonwebtoken",
      "https://www.npmjs.com/package/bcryptjs",
      "https://www.npmjs.com/package/validator",
      "https://www.npmjs.com/package/csurf",
      "https://www.npmjs.com/package/express-validator",
      "https://www.npmjs.com/package/@hapi/joi",
      "https://www.npmjs.com/package/joi-objectid",
      "https://www.google.com/search?q=joi+password+complexity&oq=joi+passwor+com&aqs=chrome.1.69i57j0l7.4399j0j1&sourceid=chrome&ie=UTF-8",
    ],
    Tooltips: ["https://iamceege.github.io/tooltipster/"],
    WebPack: [
      "https://www.npmjs.com/package/webpack-dev-server",
      "https://www.npmjs.com/package/webpack-cli",
      "https://www.npmjs.com/package/webpack",
    ],
  },
  Javascript_Frameworks: {
    Angular: [
      "https://angular.io/",
      "https://cli.angular.io/",
      "https://augury.rangle.io/",
      "https://angular.io/api?type=pipe",
      "https://medium.com/@littleStudent/deploying-angular-cli-projects-to-now-sh-e739c31053ac",
      "https://material.angular.io/",
      "https://ngrx.io/",
      "https://material.io/resources/icons/?style=baseline",
      "https://github.com/angular/flex-layout",
      "https://material.angular.io/guide/theming",
    ],
    Electron: [
      "https://www.electronjs.org/",
      "https://www.electronjs.org/docs/api",
      "https://ourcodeworld.com/articles/read/524/how-to-use-live-reload-in-your-electron-project",
    ],
    Gatsby: ["https://www.gatsbyjs.org/"],
    NextJS: [
      "https://zeit.co/blog/next5",
      "https://nextjs.org/",
      "https://nextjs.org/learn/basics/deploying-nextjs-app/deploy",
      "https://nextjs.org/learn/excel/typescript/create-tsconfig",
    ],
    NodeJS: [
      "https://nodejs.org/en/docs/",
      "https://expressjs.com/en/4x/api.html",
      "https://github.com/goldbergyoni/nodebestpractices?utm_source=mybridge&utm_medium=blog&utm_campaign=read_more",
      "https://github.com/sindresorhus/awesome-nodejs",
      "https://nodeweekly.com/",
      "https://nodejs.org/en/",
    ],
    React: [
      "https://www.npmjs.com/package/create-react-app",
      "https://www.npmjs.com/package/react-dom",
      "https://www.npmjs.com/package/react-scripts",
      "https://www.npmjs.com/package/react",
      "https://www.npmjs.com/package/react-tilt",
      "https://reactjs.org/docs/cdn-links.html",
      "https://reacttraining.com/react-router/",
      "https://www.npmjs.com/package/react-router-dom",
      "https://reactdesktop.js.org/",
      "https://reactnative.dev/",
      "https://www.npmjs.com/package/generate-react-component",
      "https://material-ui.com/",
      "https://projects.wojtekmaj.pl/react-lifecycle-methods-diagram/",
      "https://reactcommunity.org/react-transition-group/",
      "https://dev.to/loujaybee/using-create-react-app-with-express",
      "https://jaredpalmer.com/formik/",
      "https://blog.logrocket.com/automatically-generate-your-own-react-components-with-plop-js-2da3b39914f3/",
      "https://chrome.google.com/webstore/detail/react-developer-tools/fmkadmapgofadopljbjfkapdkoienihi/related",
      "https://github.com/maicki/why-did-you-update",
      "https://www.npmjs.com/package/gh-pages",
      "https://create-react-app.dev/docs/deployment/",
      "https://glamorous.rocks/",
      "https://github.com/css-modules/css-modules",
      "https://github.com/styled-components/babel-plugin-styled-components",
      "https://testing-library.com/docs/react-testing-library/intro",
    ],
    Redux: [
      "https://www.npmjs.com/package/react-redux",
      "https://redux.js.org/introduction/installation",
      "https://www.npmjs.com/package/redux",
      "https://www.npmjs.com/package/redux-saga",
      "https://www.npmjs.com/package/redux-thunk",
      "https://redux-saga.js.org/",
      "https://www.npmjs.com/package/redux-logger",
      "https://chrome.google.com/webstore/detail/redux-devtools/lmhkpmbekcpmknklioeibfkpmmfibljd/related?hl=en",
      "https://github.com/reduxjs/reselect",
      "https://www.npmjs.com/package/redux-form",
      "https://github.com/final-form/react-final-form#-react-final-form",
      "https://redux-form.com/8.3.0/",
    ],
    RxJS: [
      "https://rxjs-dev.firebaseapp.com/",
      "https://out.stegrider.now.sh/",
      "https://rxjs-dev.firebaseapp.com/guide/operators",
    ],
    TypeScript: [
      "https://www.typescriptlang.org/index.html",
      "https://definitelytyped.org/",
      "https://www.npmjs.com/package/ts-node-dev",
    ],
  },
  Deployment: {
    Domains: [
      "https://www.namecheap.com/",
      "https://www.freenom.com/en/index.html?lang=en",
      "https://js.org/",
      "https://www.domcomp.com/",
    ],
    Hosting: [
      "https://www.digitalocean.com/",
      "https://www.heroku.com/",
      "https://vercel.com/",
    ],
    Optimization: [
      "https://kinsta.com/learn/page-speed/",
      "https://caniuse.com/",
      "https://www.giftofspeed.com/gzip-test/",
      "https://jscompress.com/#",
      "https://www.minifier.org/",
      "https://imagecompressor.com/",
      "https://parceljs.org/",
      "https://prerender.io/",
      "https://progressivetooling.com/",
      "https://sizzy.co/",
    ],
    Security: [
      "https://www.cloudflare.com/",
      "https://developer.mozilla.org/en-US/docs/Web/HTTP/CORS",
      "https://expressjs.com/en/resources/middleware/cookie-session.html",
      "https://console.developers.google.com/",
      "https://developers.google.com/identity/sign-in/web/reference",
      "https://github.com/dwyl/hapi-auth-jwt2/issues/48#issuecomment-417905728",
      "https://letsencrypt.org/",
      "https://www.miraclesalad.com/webtools/md5.php",
      "https://www.hacksplaining.com/lessons",
      "https://passwordsgenerator.net/",
      "https://jwt.io/",
    ],
    Testing: [
      "https://nightwatchjs.org/",
      "https://webdriver.io/",
      "https://devexpress.github.io/testcafe/",
      "http://www.nightmarejs.org/",
      "https://www.cypress.io/",
    ],
    Docker: [
      "https://hub.docker.com/",
      "https://docs.docker.com/engine/install/ubuntu/",
      "https://linuxconfig.org/how-to-install-docker-on-ubuntu-20-04-lts-focal-fossa",
      "https://www.digitalocean.com/community/questions/how-to-fix-docker-got-permission-denied-while-trying-to-connect-to-the-docker-daemon-socket",
      "https://www.digitalocean.com/community/tutorials/how-to-remove-docker-images-containers-and-volumes",
      "https://www.digitalocean.com/community/tutorials/how-to-remove-docker-images-containers-and-volumes#:~:text=Remove%20all%20images,docker%20images%20-a",
    ],
    Analytics: [
      "https://developers.google.com/speed/pagespeed/insights/",
      "https://marketingplatform.google.com/about/analytics/",
    ],
    GoogleCloud: [
      "https://cloud.google.com/sdk/docs/quickstarts",
      "https://console.cloud.google.com/",
    ],
  },
  Styling: {
    Backgrounds: [
      "https://leaverou.github.io/css3patterns/",
      "https://vincentgarreau.com/particles.js/",
    ],
    Bootstrap: [
      "https://www.creative-tim.com/bootstrap-themes/ui-kit?direction=asc&sort=price",
      "http://www.mashup-template.com/templates.html",
      "https://startbootstrap.com/themes/",
      "https://mdbootstrap.com/freebies/",
      "https://www.creative-tim.com/",
      "https://reactstrap.github.io/",
    ],
    Colors: [
      "https://flatuicolors.com/",
      "https://www.materialpalette.com/",
      "https://colorhunt.co/",
      "https://www.webdesignrankings.com/resources/lolcolors/",
      "https://uigradients.com/#PlayingwithReds",
      "http://paletton.com/#uid=1000u0kllllaFw0g0qFqFg0w0aF",
      "https://www.0to255.com/",
    ],
    Icons: [
      "https://ionicons.com/",
      "https://fontawesome.com/?from=io",
      "https://www.flaticon.com/",
      "https://iconmonstr.com/",
      "https://icons8.com/",
      "https://icon54.com/",
      "https://www.swifticons.com/",
      "http://fontastic.me/",
      "https://geticonjar.com/",
      "https://icomoon.io/",
      "https://realfavicongenerator.net/",
    ],
    Illustrations: [
      "https://iconscout.com/paper-illustrations",
      "https://www.humaaans.com/",
      "https://www.kapwing.com/404-illustrations",
      "https://getwaves.io/",
      "https://delesign.com/free-designs/graphics",
      "https://icons8.com/ouch",
      "https://mixkit.co/free-stock-art/",
      "https://products.ls.graphics/paaatterns/",
    ],
    ImageEditing: ["https://www.remove.bg/", "https://www.imgbot.ai/"],
    Images: [
      "https://unsplash.com/",
      "http://thestocks.im/",
      "https://isorepublic.com/",
      "https://pixabay.com/",
      "https://www.toptal.com/designers/subtlepatterns/",
      "https://www.istockphoto.com/",
      "https://randomuser.me/",
      "https://startupstockphotos.com/",
      "https://placeit.net/",
      "https://www.canva.com/",
      "https://robohash.org/",
      "https://landingstock.com/",
      "https://picsum.photos/",
    ],
    Logos: [
      "https://hatchful.shopify.com/",
      "https://www.squarespace.com/logo#N4IghgrgLgFgpgExALgGZgDYGc4F8gAA",
      "https://www.namecheap.com/logo-maker/",
    ],
    Mockdown: ["https://epic.ai/mockdown/#section-connect"],
    Typography: [
      "https://fonts.google.com/",
      "https://www.fontsquirrel.com/",
      "https://www.creativebloq.com/graphic-design-tips/best-free-fonts-for-designers-1233380",
      "https://www.myfonts.com/",
      "https://www.typetester.org/",
      "http://www.typogui.de/",
      "https://unicode-table.com/en/",
      "https://www.supremo.co.uk/typeterms/",
      "https://app.programmingfonts.org/#aurulent",
    ],
    UIToolkits: [
      "https://www.creative-tim.com/bootstrap-themes/free",
      "https://startbootstrap.com/templates/",
      "https://mdbootstrap.com/docs/react/",
      "https://blueprintjs.com/",
    ],
    Videos: [
      "https://mixkit.co/",
      "https://www.pexels.com/videos",
      "https://coverr.co/",
    ],
  },
  CSS: {
    Grid: [
      "https://cssgridgarden.com/",
      "http://grid.malven.co/",
      "http://www.responsivegridsystem.com/",
    ],
    Flexbox: ["http://flexboxfroggy.com/"],
    Components: [
      "https://styled-components.com/",
      "https://interfacer.xyz/",
      "https://w3hubs.com/image-in-text-using-css/",
    ],
    Animation: [
      "https://angrytools.com/css/animation/",
      "https://angrytools.com/css-generator/",
      "https://daneden.github.io/animate.css/",
      "https://easings.net/en",
    ],
    MediaQueries: [
      "https://angrytools.com/css/mediaquery/",
      "https://www.mydevice.io/",
    ],
    Selectors: [
      "https://code.tutsplus.com/tutorials/the-30-css-selectors-you-must-memorize--net-16048",
      "https://developer.mozilla.org/en-US/docs/Learn/CSS/Building_blocks/Selectors/Combinators",
    ],
    References: [
      "http://tympanus.net/codrops/css_reference/",
      "https://developer.mozilla.org/en-US/docs/Web/CSS/Reference",
      "https://developer.mozilla.org/en-US/docs/Web/CSS/CSS_Box_Model/Mastering_margin_collapsing",
      "https://css-tricks.com/almanac/",
    ],
    Utils: [
      "https://bennettfeely.com/clippy/",
      "https://cubic-bezier.com/#.17,.67,.83,.67",
      "https://meyerweb.com/eric/tools/css/reset/",
    ],
    Frameworks: [
      "https://bulma.io/",
      "https://materializecss.com/getting-started.html",
      "https://semantic-ui.com/",
    ],
    SASS: [
      "https://www.npmjs.com/package/node-sass?activeTab=versions",
      "https://edabit.com/challenge/ARr5tA458o2tC9FTN",
    ],
  },
  Databases: {
    FunApis: [
      "https://api.github.com/",
      "https://apilist.fun/",
      "https://jsonplaceholder.typicode.com/",
      "https://dog.ceo/dog-api/",
      "https://swapi.co/",
      "https://www.twilio.com/docs/usage/api",
      "https://www.ibm.com/cloud/watson-speech-to-text",
      "https://public-apis.xyz/",
      "https://play.elevatorsaga.com/",
      "http://www.omdbapi.com/",
      "https://unsplash.com/documentation",
    ],
    Firebase: [
      "https://firebase.google.com/",
      "https://github.com/angular/angularfire",
      "https://console.firebase.google.com/u/0/?pli=1",
      "https://firebase.google.com/docs/auth",
      "https://firebase.google.com/docs/firestore",
      "https://keep.google.com/u/0/#home",
    ],
    LoadTesting: [
      "https://artillery.io/",
      "https://github.com/JoeDog/siege",
      "https://github.com/giltene/wrk2",
      "https://www.npmjs.com/package/loadtest",
    ],
    MongoDB: [
      "https://docs.mongodb.com/manual/",
      "https://www.mongodb.com/",
      "https://mongoosejs.com/docs/guide.html",
      "https://www.mongodb.com/download-center/community",
      "https://docs.mongodb.com/manual/tutorial/install-mongodb-on-os-x-tarball/",
      "https://docs.mongodb.com/manual/tutorial/install-mongodb-on-os-x/",
      "https://www.mongodb.com/download-center/compass",
      "https://www.npmjs.com/package/fawn",
      "https://www.docs4dev.com/docs/en/mongodb/v3.6/reference/tutorial-perform-two-phase-commits.html",
      "https://www.npmjs.com/package/winston-mongodb",
    ],
    MySQL: ["https://sequelize.org/", "https://www.npmjs.com/package/mysql"],
    PostgreSQL: [
      "http://www.psequel.com/",
      "https://devcenter.heroku.com/articles/heroku-postgresql",
      "https://docs.aws.amazon.com/es_es/AmazonRDS/latest/UserGuide/USER_ConnectToPostgreSQLInstance.html",
      "https://docs.microsoft.com/en-us/sql/database-engine/configure-windows/configure-a-windows-firewall-for-database-engine-access?view=sql-server-2014&redirectedfrom=MSDN#SSMSProcedure",
      "https://www.postgresql.org/",
    ],
    Serverless: ["https://www.serverless.com/"],
    SQLite: [
      "https://www.sqlitetutorial.net/sqlite-nodejs/connect/",
      "https://www.sqlitetutorial.net/sqlite-cheat-sheet/",
    ],
  },
  Inspiration: {
    Design: [
      "https://www.newdesigngroup.ca/website-design/web-design-process-infographic/",
      "https://www.behance.net/",
      "https://www.calltoidea.com/",
      "https://dribbble.com/",
      "https://land-book.com/",
      "https://mediaqueri.es/",
      "https://onepagelove.com/",
      "https://www.siteinspire.com/",
    ],
  },
  Planning: {
    WireFraming: [
      "https://balsamiq.com/wireframes/desktop/",
      "https://coggle.it/?lang=en-US",
    ],
    DataModeling: [
      "https://hackolade.com/nosqldb/mongodb-data-modeling.html",
      "https://robomongo.org/",
    ],
    Drawing: ["https://app.diagrams.net/", "https://sketch.io/sketchpad/"],
  },
  Learn: {
    BigO: [
      "https://www.youtube.com/watch?v=kS_gr2_-ws8",
      "https://www.interviewcake.com/article/java/big-o-notation-time-and-space-complexity",
      "https://www.youtube.com/watch?v=v4cd1O4zkGw",
    ],
    CodingChallenges: [
      "https://www.codewars.com/",
      "https://coderbyte.com/",
      "https://edabit.com/challenges/javascript",
      "https://github.com/MaximAbramchuck/awesome-interview-questions",
      "https://leetcode.com/",
      "https://www.youtube.com/watch?v=XKu_SEDAykw",
      "https://adventofcode.com/",
    ],
    ComputerScience: [
      "https://www.khanacademy.org/computing/computer-science/",
      "https://humanwhocodes.com/blog/2012/10/02/computer-science-and-javascript-merge-sort/",
      "http://nandgame.com/",
      "https://github.com/verekia/js-stack-from-scratch",
    ],
    DataStructures: [
      "https://visualgo.net/en",
      "https://www.bigocheatsheet.com/",
    ],
    Sorting: [
      "https://www.toptal.com/developers/sorting-algorithms",
      "https://khan4019.github.io/front-end-Interview-Questions/sort.html",
    ],
  },
  Workspace: {
    Environment: [
      "https://themer.dev/",
      "https://www.sketch.com/",
      "https://www.producthunt.com/posts/sketch-palettes",
      "https://medium.com/@jeongwhanchoi/install-tmux-on-osx-and-basics-commands-for-beginners-be22520fd95e",
      "https://macromates.com/",
      "https://www.perforce.com/downloads/visual-merge-tool",
    ],
    Terminal: [
      "https://formulae.brew.sh/formula/tree",
      "https://formulae.brew.sh/formula/speedtest-cli",
      "https://formulae.brew.sh/formula/cowsay",
      "https://brew.sh/",
      "https://github.com/powerline/fonts",
      "https://github.com/agnoster/agnoster-zsh-theme/issues/39#issuecomment-307338817",
      "https://medium.com/@marcosantonocito/install-zsh-and-oh-my-zsh-on-osx-10-11-el-capitan-cfaa0ebb97dc",
      "https://evdokimovm.github.io/windows/zsh/shell/syntax/highlighting/ohmyzsh/hyper/terminal/2017/02/24/how-to-install-zsh-and-oh-my-zsh-on-windows-10.html",
      "https://github.com/source-foundry/Hack-windows-installer/releases/tag/v1.6.0",
      "https://github.com/nodesource/distributions/blob/master/README.md#debinstall",
      "https://github.com/b-ryan/powerline-shell",
      "https://medium.com/@cosmvs/oh-my-zsh-configuration-guide-for-macos-terminal-3ee6003b09d5",
    ],
    TouchTyping: [
      "https://zty.pe/",
      "https://www.typingclub.com/",
      "https://www.typingstudy.com/lesson/1/extra_word_drill",
      "https://www.gnu.org/savannah-checkouts/gnu/gtypist/gtypist.html",
    ],
    Plugins: [
      "https://marketplace.visualstudio.com/items?itemName=naumovs.theme-oceanicnext",
      "https://marketplace.visualstudio.com/items?itemName=formulahendry.auto-close-tag",
      "https://marketplace.visualstudio.com/items?itemName=formulahendry.auto-rename-tag",
      "https://marketplace.visualstudio.com/items?itemName=naumovs.color-highlight",
      "https://marketplace.visualstudio.com/items?itemName=Rubymaniac.vscode-paste-and-indent",
      "https://marketplace.visualstudio.com/items?itemName=christian-kohler.path-intellisense",
      "https://marketplace.visualstudio.com/items?itemName=esbenp.prettier-vscode",
      "https://marketplace.visualstudio.com/items?itemName=alefragnani.project-manager",
      "https://marketplace.visualstudio.com/items?itemName=AndersEAndersen.html-class-suggestions#:~:text=",
      "https://marketplace.visualstudio.com/items?itemName=ecmel.vscode-html-css",
      "https://marketplace.visualstudio.com/items?itemName=abusaidm.html-snippets",
      "https://marketplace.visualstudio.com/items?itemName=pranaygp.vscode-css-peek",
      "https://marketplace.visualstudio.com/items?itemName=mkaufman.HTMLHint",
      "https://marketplace.visualstudio.com/items?itemName=Zignd.html-css-class-completion",
      "https://marketplace.visualstudio.com/items?itemName=bierner.lit-html",
      "https://marketplace.visualstudio.com/items?itemName=ritwickdey.LiveServer",
      "https://marketplace.visualstudio.com/items?itemName=donjayamanne.jquerysnippets",
      "https://marketplace.visualstudio.com/items?itemName=mrmlnc.vscode-autoprefixer",
      "https://marketplace.visualstudio.com/items?itemName=streetsidesoftware.code-spell-checker",
      "https://marketplace.visualstudio.com/items?itemName=lukasz-wronski.ftp-sync",
      "https://marketplace.visualstudio.com/items?itemName=TabNine.tabnine-vscode",
      "https://marketplace.visualstudio.com/items?itemName=PKief.material-icon-theme",
      "https://marketplace.visualstudio.com/items?itemName=firefox-devtools.vscode-firefox-debug",
      "https://marketplace.visualstudio.com/items?itemName=msjsdiag.debugger-for-chrome",
      "https://marketplace.visualstudio.com/items?itemName=dbaeumer.vscode-eslint",
      "https://marketplace.visualstudio.com/items?itemName=mrmlnc.vscode-scss",
      "https://marketplace.visualstudio.com/items?itemName=xabikos.JavaScriptSnippets",
      "https://marketplace.visualstudio.com/items?itemName=VisualStudioExptTeam.vscodeintellicode",
      "https://marketplace.visualstudio.com/items?itemName=felixfbecker.php-intellisense",
      "https://marketplace.visualstudio.com/items?itemName=christian-kohler.npm-intellisense",
      "https://marketplace.visualstudio.com/items?itemName=leizongmin.node-module-intellisense",
      "https://marketplace.visualstudio.com/items?itemName=mrmlnc.vscode-less",
      "https://marketplace.visualstudio.com/items?itemName=dbaeumer.jshint",
      "https://marketplace.visualstudio.com/items?itemName=auchenberg.vscode-browser-preview",
      "https://marketplace.visualstudio.com/items?itemName=donjayamanne.githistory",
      "https://marketplace.visualstudio.com/items?itemName=felipecaputo.git-project-manager",
      "https://marketplace.visualstudio.com/items?itemName=eamodio.gitlens",
      "https://marketplace.visualstudio.com/items?itemName=ms-python.python",
      "https://marketplace.visualstudio.com/items?itemName=ms-dotnettools.csharp",
      "https://marketplace.visualstudio.com/items?itemName=redhat.java",
      "https://marketplace.visualstudio.com/items?itemName=vscode-icons-team.vscode-icons",
      "https://marketplace.visualstudio.com/items?itemName=ms-mssql.mssql",
      "https://marketplace.visualstudio.com/items?itemName=eg2.vscode-npm-script",
      "https://marketplace.visualstudio.com/items?itemName=johnpapa.Angular2",
      "https://marketplace.visualstudio.com/items?itemName=DotJoshJohnson.xml",
      "https://marketplace.visualstudio.com/items?itemName=dsznajder.es7-react-js-snippets",
      "https://marketplace.visualstudio.com/items?itemName=aaron-bond.better-comments",
      "https://marketplace.visualstudio.com/items?itemName=jchannon.csharpextensions",
      "https://marketplace.visualstudio.com/items?itemName=joelday.docthis",
      "https://marketplace.visualstudio.com/items?itemName=sidthesloth.html5-boilerplate",
      "https://marketplace.visualstudio.com/items?itemName=quicktype.quicktype",
      "https://marketplace.visualstudio.com/items?itemName=ms-vscode.cpptools",
      "https://marketplace.visualstudio.com/items?itemName=Shan.code-settings-sync",
      "https://marketplace.visualstudio.com/items?itemName=mikestead.dotenv",
      "https://quokkajs.com/",
    ],
  },
};
